import { object, string } from 'yup'

export const addressSchema = object().shape({
  cep: string().required('Preencha o campo').min(8, 'CEP inválido').max(8, 'CEP inválido'),
  address: string().required('Preencha o campo').min(1),
  number: string().required('Preencha o campo').min(1),
  complement: string(),
  neighborhood: string().required('Preencha o campo').min(1),
  city: string().required('Preencha o campo').min(1),
  state: string().required('Preencha o campo').min(1)
})